import { render } from "./ChronosKairosPage.vue?vue&type=template&id=0ca7cdbe"
import script from "./ChronosKairosPage.vue?vue&type=script&lang=js"
export * from "./ChronosKairosPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__